import { amplitudeTrack } from "@cw-elements/analytics-provider";
import {
  sidebarItemClicked,
  createNewAssessmentClicked,
  assessmentsFilterApplied,
  assessmentReportClicked,
  assessmentEditClicked,
  assessmentCloneClicked,
  assessmentDeleteClicked,
  assessmentJourney,
} from "constants/AnalyticsEvents";

// Maps AssessmentSteps enum values (src/constants/Assesments.ts) to the display
// names used by the Amplitude tracking plan (Carbon Engine Web - amplitude events.docx).
export const AssessmentStepDisplayNames: Record<string, string> = {
  "basic-info": "Basic Info",
  applications: "Applications",
  practices: "Practices & Machinery Usage",
  "soil-characteristics": "Soil Characteristics",
  yield: "Yield",
};

export const trackSidebarItemClicked = (sidebarItem: string): void => {
  amplitudeTrack(sidebarItemClicked, { "Sidebar Item": sidebarItem });
};

export const trackCreateNewAssessmentClicked = (properties: {
  workspaceId?: string;
  organizationName?: string;
  buttonPlacement: "Bottom Center" | "Top Right";
}): void => {
  amplitudeTrack(createNewAssessmentClicked, {
    "Workspace Name": properties.workspaceId,
    "Organization Name": properties.organizationName,
    "Button Placement": properties.buttonPlacement,
  });
};

export const trackAssessmentsFilterApplied = (properties: {
  filterType: "Year" | "Search Box";
  selectedValue: string | number | boolean;
}): void => {
  amplitudeTrack(assessmentsFilterApplied, {
    "Filter Type": properties.filterType,
    "Selected Value": properties.selectedValue,
  });
};

export const trackAssessmentReportClicked = (properties: {
  assessmentName?: string;
  crop?: string;
  status: string;
  actionResult: "PDF Viewed" | "Error Displayed";
}): void => {
  amplitudeTrack(assessmentReportClicked, {
    "Assessment Name": properties.assessmentName,
    Crop: properties.crop,
    Status: properties.status,
    "Action Result": properties.actionResult,
  });
};

export const trackAssessmentEditClicked = (properties: {
  assessmentName?: string;
  crop?: string;
  status?: string;
  stepName?: string;
}): void => {
  amplitudeTrack(assessmentEditClicked, {
    "Assessment Name": properties.assessmentName,
    Crop: properties.crop,
    Status: properties.status,
    "Step Name": properties.stepName,
  });
};

export const trackAssessmentCloneClicked = (properties: {
  originalAssessmentName?: string;
  newAssessmentName?: string;
  crop?: string;
  status: string;
}): void => {
  amplitudeTrack(assessmentCloneClicked, {
    "Original Assessment Name": properties.originalAssessmentName,
    "New Assessment Name": properties.newAssessmentName,
    Crop: properties.crop,
    Status: properties.status,
  });
};

export const trackAssessmentDeleteClicked = (properties: {
  assessmentName?: string;
  actionTaken: "Delete" | "Cancel";
}): void => {
  amplitudeTrack(assessmentDeleteClicked, {
    "Assessment Name": properties.assessmentName,
    "Action Taken": properties.actionTaken,
  });
};

export const trackAssessmentJourney = (properties: {
  assessmentName?: string;
  status?: string;
  stepName?: string;
  cfpCropPathway?: string;
  crop?: string;
  year?: string | number;
  workspaceId?: string;
  organizationName?: string;
}): void => {
  amplitudeTrack(assessmentJourney, {
    "Assessment Name": properties.assessmentName,
    Status: properties.status,
    "Step Name": properties.stepName,
    "CFP Crop Pathway": properties.cfpCropPathway,
    Crop: properties.crop,
    Year: properties.year,
    "Workspace Name": properties.workspaceId,
    "Organization Name": properties.organizationName,
  });
};
